enum ECompanySubscribersType {
  COMPANY = 'company',
  GROUP = 'group',
}

export default ECompanySubscribersType;
